module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_6-7e465d66fdb5536aa60d33b2c3462007.png";